module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_22.cbed55cb.png";